import { ProductRibbon, Rating } from "@shared/ui.components";
import { colours } from "@shared/ui.design-system";
import { Typography } from "@shared/ui.primitives";
import React from "react";

import * as styles from "./TopBlock.css";

type Ribbon = {
  key: string;
  text: string;
};
export interface TopBlockProps {
  brandName?: string;
  title: string;
  subtitle: string;
  rating: number;
  reviewCount: number;
  ribbons?: Ribbon[];
  trackReviewsClick: () => void;
}

export const TopBlock: React.FC<TopBlockProps> = ({
  brandName = "",
  title,
  subtitle,
  ribbons,
  rating,
  reviewCount,
  trackReviewsClick
}) => {
  return (
    <div className={styles.productInfoContainer}>
      <div className={styles.productHeader}>
        {brandName && (
          <Typography variant="franchise-lg">{brandName}</Typography>
        )}

        {ribbons?.length
          ? ribbons.map((ribbon) => (
              <div key={ribbon.key} className={styles.productRibbon}>
                <ProductRibbon ribbonKey={ribbon.key} text={ribbon.text} />
              </div>
            ))
          : null}
      </div>
      {title && (
        <div
          data-testid="product-title-subtitle"
          className={styles.productTitle}
        >
          <Typography
            variant="product-md"
            as="h1"
          >{`${title}${subtitle}`}</Typography>
        </div>
      )}
      <div className={styles.productReviews}>
        <Rating
          totalReviews={reviewCount}
          ratingValue={rating}
          activeColor={colours.accent.strong}
          trackReviewsClick={trackReviewsClick}
          renderCountAsLink
        />
      </div>
    </div>
  );
};
